import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=6a270c60"
import script from "./Error.vue?vue&type=script&lang=ts&setup=true"
export * from "./Error.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Error.vue?vue&type=style&index=0&id=6a270c60&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports